export const EDIT_GROUP_METADATA_REQUEST = 'EDIT_GROUP_METADATA_REQUEST';
export const EDIT_GROUP_METADATA_REQUEST_FAILURE = 'EDIT_GROUP_METADATA_REQUEST_FAILURE';

export const EDIT_GROUP_MODEL_PERMISSIONS_REQUEST = 'EDIT_GROUP_MODEL_PERMISSIONS_REQUEST';
export const EDIT_GROUP_MODEL_PERMISSIONS_REQUEST_SUCCESS = 'EDIT_GROUP_MODEL_PERMISSIONS_REQUEST_SUCCESS';
export const EDIT_GROUP_MODEL_PERMISSIONS_REQUEST_FAILURE = 'EDIT_GROUP_MODEL_PERMISSIONS_REQUEST_FAILURE';

export const EDIT_GROUP_MODULE_PERMISSIONS_REQUEST = 'EDIT_GROUP_MODULE_PERMISSIONS_REQUEST';
export const EDIT_GROUP_MODULE_PERMISSIONS_SUCCESS = 'EDIT_GROUP_MODULE_PERMISSIONS_SUCCESS';
export const EDIT_GROUP_MODULE_PERMISSIONS_FAILURE = 'EDIT_GROUP_MODULE_PERMISSIONS_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group_update/redux/constants/edit_group_data.constants.js